'use client'

import { InstructionSize } from '@/app/[locale]/product/[slug]/_components/product-info-sizes/instructions-size'
import { getValue } from '@/lib/utils'
import { useProductDetailSafe } from '../../context/product-detail-context'
import {
  getSetdoPart,
  useProductDetailStore,
} from '../../hooks/use-product-detail-store'
import { ProductInfoVariantItem } from '../product-info/product-info-variant-item'
import { InfoSizeShortItem } from './info-size-short-item'


export const InfoSizesShortCombo = () => {
  const { comboSelectedInfo, product } = useProductDetailSafe()
  const {
    isDisableComboSize,
    handleComboSizeChange,
    setIsSizeGuideDrawerOpen,
  } = useProductDetailStore()

  const combo = product?.combo

  if (!combo) return null

  return (
    <>
      {combo?.options?.map((item, optionIndex) => (
        <div
          key={item.title}
          className='border-l border-l-neutral-200 py-4 pl-2 2xl:pl-6'
        >
          <p className='mb-1 text-sm leading-4.5 text-neutral-600'>
            {item.title}:
            <span className='ml-3 font-semibold text-neutral-900'>
              {' '}
              {getValue(comboSelectedInfo, `option${optionIndex + 1}`, '')}
            </span>
          </p>
          {item?.option_id?.includes('color') ? (
            <>
              <ul className='grid grid-cols-6 gap-2 gap-y-3 xl:grid-cols-4'>
                {item.values.map((variant) => (
                  <li key={variant.value} className='variant-item'>
                    <ProductInfoVariantItem
                      isActive={
                        getValue(
                          comboSelectedInfo,
                          `option${optionIndex + 1}`,
                          ''
                        ) === variant.value
                      }
                      onClick={() =>
                        handleComboSizeChange(variant.value, optionIndex)
                      }
                      title={variant.label}
                      imageUrl={variant?.image || ''}
                    />
                  </li>
                ))}
              </ul>
            </>
          ) : (
            <ul className='flex flex-wrap gap-1 lg:gap-2 lg:gap-y-2'>
              {item.values.map((value) => (
                <InfoSizeShortItem
                  key={value.value}
                  isActive={
                    getValue(
                      comboSelectedInfo,
                      `option${optionIndex + 1}`,
                      ''
                    ) === value.value
                  }
                  onClick={() =>
                    handleComboSizeChange(value.value, optionIndex)
                  }
                  title={value.label}
                  isDisabled={isDisableComboSize(value.value, optionIndex)}
                />
              ))}
            </ul>
          )}

          {item?.option_id?.includes('size') &&
            getSetdoPart(product, optionIndex)?.product_id && (
              <InstructionSize
                productId={getSetdoPart(product, optionIndex)?.product_id}
                product={product}
                setIsSizeGuideDrawerOpen={setIsSizeGuideDrawerOpen}
              />
            )}
        </div>
      ))}
    </>
  )
}
